import * as set_ from 'lodash.set';
import isEmpty from 'lodash.isempty';
import { Selectors } from '../../store/selectors';

const set = set_;

const trimSpaces = (value) => {
    return value ? value.trim() : '';
};

const validateUserConsent = (shopper, tcpaEnabled, tcpaConsentRequired) => {
    if (tcpaEnabled && tcpaConsentRequired && shopper.userConsent !== 'checked') {
        if (shopper.contactPreferences.phone || shopper.contactPreferences.sms) {
            return false;
        }
    }

    return true;
};

const validate = (values, { isTcpaEnabled, isTCPACheckboxHidden, isPhoneNumberRequired }) => {
    const {
        validateEmail,
        validateFirstName,
        validateLastName,
        validatePhone,
        validateContactPreferences
    } = Selectors.getInstance().additionalSelectors.validateSelectors;

    const errors = {};
    if (!values) return errors;
    const { shopper } = values;

    let toTest = trimSpaces(shopper.firstName);
    if (!validateFirstName(toTest)) {
        set(errors, 'shopper.firstName', true);
    }

    toTest = trimSpaces(shopper.lastName);
    if (!validateLastName(toTest)) {
        set(errors, 'shopper.lastName', true);
    }

    toTest = trimSpaces(shopper.email);
    if (!validateEmail(toTest)) {
        set(errors, 'shopper.email', true);
    }

    toTest = trimSpaces(shopper.phone);
    let contactPreferences = { phone: false, sms: false };
    if (shopper && shopper.contactPreferences) {
        contactPreferences = shopper.contactPreferences;
    }

    if (toTest === '' && (contactPreferences.phone || contactPreferences.sms)) {
        set(errors, 'shopper.phone', true);
    } else if ((isPhoneNumberRequired || toTest !== '') && !validatePhone(toTest)) {
        set(errors, 'shopper.phone', true);
    }

    // Email is required when there are no methods of communication
    if (!validateContactPreferences(shopper)) {
        set(errors, 'shopper.contactPreferences', true);
    }

    toTest = trimSpaces(shopper.message);
    if (toTest && toTest.length > 500) {
        set(errors, 'shopper.message', true);
        set(errors, 'message', true);
    }

    if (!validateUserConsent(shopper, isTcpaEnabled, !isTCPACheckboxHidden)) {
        set(errors, 'shopper.userConsent', true);
    }

    if (!isEmpty(errors)) {
        set(errors, '_error', 'Please correct the highlighted fields');
    }

    return errors;
};

export default validate;
